const Wallet = ({ color, type }) => {
  const regular = (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M34.7261 1.42387C35.2756 1.79594 35.6048 2.41635 35.6048 3.07997V13.0533H38.9381C42.3991 13.0533 45.2048 15.859 45.2048 19.32V39.8C45.2048 43.7322 42.0171 46.92 38.0848 46.92H9.92479C5.99277 46.92 2.8052 43.7326 2.80479 39.8007L2.79541 15.0734C2.79735 14.4793 3.058 14.071 3.15379 13.932C3.27385 13.7577 3.39619 13.6386 3.46035 13.5794C3.59265 13.4574 3.71853 13.3723 3.77974 13.332C3.91768 13.2414 4.06786 13.1592 4.19027 13.095C4.45 12.9588 4.79873 12.7926 5.20087 12.6084C6.01482 12.2356 7.161 11.7375 8.51551 11.162C11.2299 10.0088 14.8417 8.51945 18.4448 7.04859C22.0499 5.57691 25.6541 4.12056 28.3565 3.03234C29.7078 2.48817 30.834 2.03593 31.6224 1.71969L32.8608 1.22351C32.861 1.22342 32.8621 1.22296 33.6048 3.07997L32.8608 1.22351C33.4769 0.97709 34.1766 1.05181 34.7261 1.42387ZM31.6048 6.03713C31.0785 6.24863 30.4898 6.48541 29.8506 6.7428C27.1515 7.82969 23.5537 9.28348 19.9566 10.7519C18.0423 11.5334 16.1304 12.3181 14.3555 13.0533H31.6048V6.03713ZM6.79616 17.0533H38.9381C40.19 17.0533 41.2048 18.0681 41.2048 19.32V39.8C41.2048 41.5231 39.8079 42.92 38.0848 42.92H9.92479C8.20166 42.92 6.80479 41.5231 6.80479 39.8L6.79616 17.0533ZM34.4124 28.1123C35.1934 28.8933 35.1935 30.1596 34.4125 30.9407L34.3791 30.9741C33.598 31.7552 32.3317 31.7553 31.5506 30.9742C30.7695 30.1932 30.7695 28.9269 31.5505 28.1458L31.5839 28.1124C32.365 27.3313 33.6313 27.3313 34.4124 28.1123Z"
        fill={color}
      />
    </svg>
  );

  const getSVGByType = (type) => {
    switch (type) {
      case "regular":
      default:
        return regular;
    }
  };

  return getSVGByType(type);
};

export default Wallet;
